import { ReportSubstantiation, UpdateReport } from 'src/api';
import { useTheme } from 'styled-components';
import { SelectDropdownGeneric } from '../SelectDropdownGeneric';

type Props = {
  currentReport: UpdateReport | null;
  reportSubstantiationList: ReportSubstantiation[];
  updateReport: (id: string, report: UpdateReport) => void;
};

export const SubstantiationSelector = (props: Props) => {
  const theme = useTheme();
  const onChangeSubstantiation = async (value: ReportSubstantiation) => {
    if (props.currentReport?.report) {
      await props.updateReport(props.currentReport?.report, {
        ...props.currentReport,
        substantiation: value,
      });
    }
  };
  return (
    <>
      <SelectDropdownGeneric
        options={props.reportSubstantiationList.map((value, index) => ({
          value,
          label: value,
          id: index,
        }))}
        value={{
          label:
            props.currentReport?.substantiation ??
            ReportSubstantiation.UNDETERMINED,
          value:
            props.currentReport?.substantiation ??
            ReportSubstantiation.UNDETERMINED,
        }}
        label={''}
        onChange={(e) =>
          onChangeSubstantiation(e?.value as ReportSubstantiation)
        }
        customStyle={{
          controlStyle: {
            backgroundColor: theme.isVaultVariant
              ? theme.newPalette.neutral.N200
              : theme.atlas.semantic.color.surface.variant,
            height: '28px',
            margin: '4px 0 0 0',
          },
        }}
        menuPlacement="bottom"
        menuPosition="fixed"
        className="report-sidebar-substantiation-field"
        classNamePrefix="substantiation"
      />
    </>
  );
};
